import {
  ExtraWorkedTimeRequestStatus,
  type GetExtraWorkedTimeRequestsResponse,
} from "@clipboard-health/contract-backend-main";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { type UseQueryResult } from "@tanstack/react-query";

import { useGetExtraWorkedTimeRequestsByShift } from "./useGetExtraWorkedTimeRequestsByShift";

export type ProvisionalExtraWorkedTimeRequestResponse = GetExtraWorkedTimeRequestsResponse;
export type ProvisionalExtraWorkedTimeRequest =
  ProvisionalExtraWorkedTimeRequestResponse["data"][number];

export function useGetProvisionalExtraWorkedTimeRequest(
  shiftId: string,
  options: UseGetQueryOptions<ProvisionalExtraWorkedTimeRequestResponse> = {}
): UseQueryResult<ProvisionalExtraWorkedTimeRequestResponse> {
  return useGetExtraWorkedTimeRequestsByShift(
    shiftId,
    { status: ExtraWorkedTimeRequestStatus.PROVISIONAL },
    options
  );
}
